<template>
	<div>
	<v-form ref="form" method="POST" action="/register" @submit.prevent="onSubmit">
		<input type="hidden" name="_token" :value="csrf">
		<v-card-text>
			<label for="name">
				<span class="font-weight-medium base-label pa-2">{{ $t('fullName') }}</span>
				<span class="text--red red--text">*</span>
			</label>
			<v-text-field id="name" v-model="form.name" outlined required
										class="mt-1 base-input-1 base-rounded"
										type="text" :rules="[rules.required]"
										name="name"
										:placeholder="$t('enterEmail')"
										:error-messages="errors.name"
			/>
			<label for="email">
				<span class="font-weight-medium base-label pa-2">{{ $t('email') }}</span>
				<span class="text--red red--text">*</span>
			</label>
			<v-text-field id="email" v-model="form.email"
										class="mt-1 base-input-1 base-rounded" outlined required
										type="email" :rules="[rules.required, rules.email]"
										name="email"
										:placeholder="$t('enterEmail')"
										:error-messages="errors.email"
			/>
			<label for="password">
				<span class="font-weight-medium base-label">{{ $t('password') }}</span>
				<span class="text--red red--text">*</span>
			</label>
			<v-text-field id="password" v-model="form.password"
										class="mt-1 base-input-1 base-rounded" outlined required
										type="password" :rules="[rules.required]"
										name="password"
										:placeholder="$t('enterPassword')"
										:error-messages="errors.password"
			/>

			<label class="" for="confirmationPassword">
				<span class="font-weight-medium base-label">{{ $t('confirmPassword') }}</span>
				<span class="text--red red--text">*</span>
			</label>
			<v-text-field id="confirmationPassword" v-model="form.password_confirmation"
										class="mt-1 base-input-1 base-rounded"
										outlined required type="password" :rules="[rules.required, rules.password]"
										name="password_confirmation"
										:placeholder="$t('enterPassword')"
										:error-messages="errors.password_confirmation"
			/>

			<v-checkbox
				v-model="form.terms_accepted"
				:rules="[rules.required]"
				:error-messages="errors.terms_accepted"
			>
				<template v-slot:label>
					<v-row>
						<v-col align ="start">
							<span>
								{{ $t('termsAgreement') }}
								<a href="#" class="text-decoration-none terms-link font-weight-medium" @click.prevent="openPrivacy">
									{{ $t('privacyPolicy') }}
								</a>
							</span>
						</v-col>
					</v-row>
				</template>
			</v-checkbox>
		</v-card-text>
		<v-row justify="center" class="px-4">
			<v-col>
				<v-btn block type="submit" color="btnColor" rounded :loading="loading">
					<div class="">
								<span class="pa-2">
									<v-progress-circular v-if="loading" indeterminate :size="30" :width="4"
																			 color="white"></v-progress-circular></span>
						<span class="px-2 font-weight-bold text-h5">{{ $t("register") }}</span>
					</div>
				</v-btn>
			</v-col>
		</v-row>
	</v-form>
		<v-row justify="center" class="pt-2 pt-md-8">
			<a @click="$emit('login')">{{ $t('registerPage.loginButton') }}</a>
		</v-row>
	</div>
</template>

<script>
import rules from "../../helpers/rules";

export default {
	name: "RegisterForm",
	props: {
		loading: Boolean,
		errors: Object
	},
	data: () => ({
		form: {
			name: "",
			email: "",
			password: "",
			password_confirmation: "",
			terms_accepted: false
		},
		recaptcha: null,
		rules
	}),
	computed: {
		csrf() {
			const token = document.querySelector("meta[name=csrf-token]");
			return token ? token.getAttribute("content") : "";
		},
	},
	methods: {
		async onSubmit(event) {
			const isValid = await this.$refs.form.validate(); // Validate form
			if (!isValid) return;
			this.$emit("submit", { form: this.form, event, recaptcha: this.recaptcha });
		},
		openTerms() {
			// Open terms of service in a new window or modal
			window.open('https://drive.google.com/file/d/1NoYW2iwTR8sjLnYyFvaAUsnDzHI392nt/view', '_blank');
		},
		openPrivacy() {
			// Open privacy policy in a new window or modal
			window.open('https://drive.google.com/file/d/1NoYW2iwTR8sjLnYyFvaAUsnDzHI392nt/view', '_blank');
		}
	}
}
</script>

<style scoped>

.terms-link {
	color: #1976d2;
	text-decoration: underline !important;
}

.terms-link:hover {
	color: #1565c0;
	text-decoration: none !important;
}
</style>
